<template>
  <vca-card>
    <h2>{{ $t("expense.list.header") }}</h2>
    <vca-card class="shadowed vca-center">
      <ExpenseTable />
      <vca-popup
        v-if="current != null"
        :show="current != null"
        :title="$t('expense.popup.edit', { 0: current.name })"
        @close="current = null"
      >
        <ExpenseEdit />
      </vca-popup>
    </vca-card>
  </vca-card>
</template>

<script>
import ExpenseTable from "@/components/finance/expenses/ExpenseTable";
export default {
  name: "ExpensesList",
  components: { ExpenseTable },
  created() {
    this.$store.dispatch({ type: "expenses/list" });
  },
  computed: {
    current: {
      get() {
        return this.$store.state.expenses.current;
      },
      set(value) {
        this.$store.commit("expenses/current", value);
      },
    },
  },
};
</script>
